import { Instance } from 'mobx-state-tree';
import { RouteUnpublishingDtoModelBase } from './RouteUnpublishingDtoModel.base';

/* The TypeScript type of an instance of RouteUnpublishingDtoModel */
export interface RouteUnpublishingDtoModelType extends Instance<typeof RouteUnpublishingDtoModel.Type> {}

/* A graphql query fragment builders for RouteUnpublishingDtoModel */
export { selectFromRouteUnpublishingDto, routeUnpublishingDtoModelPrimitives, RouteUnpublishingDtoModelSelector } from './RouteUnpublishingDtoModel.base';

/**
 * RouteUnpublishingDtoModel
 *
 * Route unpublishing event
 */
export const RouteUnpublishingDtoModel = RouteUnpublishingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
